import { Route, Routes, useLocation } from "react-router-dom";

import ForgetPass from "./roles/user/auth/ForgetPass";
import Login from "./roles/user/auth/Login";
import Registration from "./roles/user/auth/Registration";
import LandingPage from "./roles/user/site/LandingPage";
import PrivacyPolicy from "./roles/user/site/PrivacyPolicy";
import TermsOfService from "./roles/user/site/TermsOfService";
import Contact from "./roles/user/site/Contact";
import HelpCenter from "./roles/user/site/HelpCenter";
import Chat from "./roles/user/chat/Chat";
import UserProfilePage from "./roles/user/profile/UserProfilePage";
import PublicProfilePage from "./roles/user/profile/PublicProfilePage";
import FileTransferPage from "./roles/user/filesystem/FileTransferPage";
import Layout from "./roles/user/layout/Layout";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { checkToken } from "./features/userSlice";
import EditProfilePage from "./roles/user/profile/EditProfilePage";
import API, { setServerUnavailableHandler } from "./utils/Api";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}

function App() {
  const dispatch = useDispatch();
  const [isServerUnavailable, setIsServerUnavailable] = useState(false);
  const [isMaintenanceLoading, setIsMaintenanceLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const showMaintenanceMessage = () => {
      if (!isMounted) return;
      setIsMaintenanceLoading(false);
      setIsServerUnavailable(true);
    };

    setServerUnavailableHandler(showMaintenanceMessage);

    const checkServer = async () => {
      try {
        await API.get("/");
        if (!isMounted) return;
        dispatch(checkToken());
        setIsServerUnavailable(false);
      } catch (error) {
        if (!isMounted) return;
        if (error?.response) {
          dispatch(checkToken());
          setIsServerUnavailable(false);
        } else {
          setIsServerUnavailable(true);
        }
      } finally {
        if (isMounted) {
          setIsMaintenanceLoading(false);
        }
      }
    };

    checkServer();

    return () => {
      isMounted = false;
      setServerUnavailableHandler(null);
    };
  }, [dispatch]);

  if (isMaintenanceLoading) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-gray-100 px-6">
        <div className="max-w-md w-full bg-white border border-gray-200 rounded-lg shadow-sm p-8 text-center">
          <h1 className="text-2xl font-bold text-gray-800 mb-3">Loading...</h1>
          <p className="text-gray-600">Checking server status. Please wait.</p>
        </div>
      </div>
    );
  }

  if (isServerUnavailable) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-gray-100 px-6">
        <div className="max-w-md w-full bg-white border border-gray-200 rounded-lg shadow-sm p-8 text-center">
          <h1 className="text-2xl font-bold text-gray-800 mb-3">Under Maintenance</h1>
          <p className="text-gray-600">Server is under maintenance. Please try again later.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<LandingPage />} />
          <Route path="file" element={<FileTransferPage />} />
          <Route path="profile" element={<UserProfilePage />} />
          <Route path="profile/:id" element={<PublicProfilePage />} />
          <Route path="edit-profile" element={<EditProfilePage />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms" element={<TermsOfService />} />
          <Route path="contact" element={<Contact />} />
          <Route path="help" element={<HelpCenter />} />
        </Route>
        {/* <Route path="chat" element={<Sample />} /> */}
        <Route path="/chat" element={<Chat />} />
        <Route path="/chat/:partnerId" element={<Chat />} />

        <Route path="/login" element={<Login />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/contact" element={<ForgetPass />} />
      </Routes>
    </div>
  );
}

export default App;
